/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { NoteBaseTypes, ScheduledDate } from '../../model/surveyData';
import { DataPeriods } from '../../types/universalTracker';

interface ReportingLevelMin {
  name: string;
  code: string;
  _id: string;
  profile?: string;
}

export interface ConfigFormData extends NoteBaseTypes {
  _id?: string; // passed when we are updating
  evidenceRequired?: boolean;
  verificationRequired?: boolean;
  isPrivate?: boolean;
  sourceName?: Blueprints;

  reportingCompany?: ReportingLevelMin;
  reportingLevel?: string;

  initiativeId?: string;
  initiativeName?: string;
  name?: string;
  period?: DataPeriods;
  year?: number;
  month?: number;
  deadlineDate?: string;
  scheduledDates?: ScheduledDate[];
}

export enum Blueprints {
  Adapter2020 = 'adapter2020',
  Adapter2022 = 'adapter2022',
  Blab2019 = 'bLab2019Blueprint',
  Gri2019 = 'gri2019',
  Gri2020 = 'gri2020',
  Baseline2019 = 'baseline2019',
  Blueprint2022 = 'blueprint2022',
  Materiality2024 = 'materiality2024',
}

export const DefaultBlueprintCode = Blueprints.Blueprint2022;
